import api from '@/api'
import errors from '@/api/errors'
import store from '@/store'

const baseUrlRef = process.env.REVIEW_API_BASE_URL_REF
const baseUrlReg = process.env.REVIEW_API_BASE_URL_REG

const createGetParams = (args) => {
  const p = {
    // セッションID
    sessionID: store.getters['commons/cookies'].encsid,
    // レビューID
    review_id: args.reviewId,
    // ソート順
    sort: args.orderValue || '1', // 0:asc 1:desc
    // 開始位置
    start: args.start || 0,
    // 取得件数
    count: args.count || 0,
    // ステータスリスト
    status: args.status || [ '2' ]
  }
  // アクセストークン
  if (store.getters['commons/cookies'].mchat) {
    p.accessToken = store.getters['commons/cookies'].mchat
  }
  // 登録した国名リスト
  if (args.country) {
    p.country = args.country
  }
  if (args.from) {
    p.from = args.from
  }
  if (args.to) {
    p.to = args.to
  }
  return p
}

const createPostParams = (args) => {
  const p = {
    // アクセストークン
    accessToken: store.getters['commons/cookies'].mchat,
    // セッションID
    sessionID: store.getters['commons/cookies'].encsid,
    // レビューID
    review_id: args.reviewId,
    // コメント本文
    description: args.description,
    // 登録アプリケーション
    application: 2,
    // 登録した国名
    country: process.env.COUNTRY
  }
  return p
}

const createDeleteParams = (args) => {
  const p = {
    // アクセストークン
    accessToken: store.getters['commons/cookies'].mchat,
    // セッションID
    sessionID: store.getters['commons/cookies'].encsid,
    // レビューID
    review_id: args.reviewId,
    // コメントID
    comment_id: args.commentId
  }
  return p
}

const createGetCommentByIdParams = (args) => {
  const p = {}
  // required
  p.sessionID = store.getters['commons/cookies'].encsid
  p.review_id = args.reviewId
  p.comment_id = args.commentId
  // アクセストークン
  if (store.getters['commons/cookies'].mchat) {
    p.accessToken = store.getters['commons/cookies'].mchat
  }
  return p
}

const onReceived = (respBody) => {
  if (respBody.resultCode !== 0) {
    console.error(`API error code ${respBody.resultCode}`)
    if (respBody.resultCode === 611) { // アクセストークンエラー
      throw new errors.AuthenticationError()
    }
    throw new Error('問題が発生したためその後の処理を継続することができませんでした。時間を置いて再度利用をお願いします。')
  }
  return respBody.data ? Promise.resolve(respBody.data) : Promise.resolve(respBody)
}

const onResistReviewCommentResult = (respBody) => {
  if (respBody.resultCode !== 0) {
    console.error(`API error code ${respBody.resultCode}`)
    if (respBody.resultCode === 611) { // アクセストークンエラー
      throw new errors.AuthenticationError()
    }
    if (respBody.resultCode === 105) { // バリデーションエラー
      throw new errors.InputValidationError(respBody.errorMessage)
    }
    throw new Error('問題が発生したためその後の処理を継続することができませんでした。時間を置いて再度利用をお願いします。')
  }
  return respBody.data ? Promise.resolve(respBody.data) : Promise.resolve(respBody)
}

export default {
  // コメント取得
  getReviewComment: (args) => {
    const params = createGetParams(args)
    return api.post(`${baseUrlRef}/getReviewComment`, params).then(onReceived)
  },
  // コメント投稿
  registReviewComment: (args) => {
    const params = createPostParams(args)
    return api.post(`${baseUrlReg}/registReviewComment`, params).then(onResistReviewCommentResult)
  },
  // コメント削除
  deleteReviewComment: (args) => {
    const params = createDeleteParams(args)
    return api.post(`${baseUrlReg}/deleteReviewComment`, params).then(onReceived)
  },
  // レビューコメント詳細
  getCommentById: (args) => {
    const params = createGetCommentByIdParams(args)
    return api.post(`${baseUrlRef}/getReviewCommentById`, params).then(onReceived)
  }
}



// WEBPACK FOOTER //
// ./src/api/comments.js